import { render, staticRenderFns } from "./InstallationsSideviewPhotosTab.vue?vue&type=template&id=7a37296e&scoped=true&class=fill-height&"
import script from "./InstallationsSideviewPhotosTab.vue?vue&type=script&lang=ts&"
export * from "./InstallationsSideviewPhotosTab.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationsSideviewPhotosTab.vue?vue&type=style&index=0&id=7a37296e&prod&scoped=true&lang=scss&"
import style1 from "./InstallationsSideviewPhotosTab.vue?vue&type=style&index=1&id=7a37296e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a37296e",
  null
  
)

export default component.exports